import React, { useState } from "react";
import Overview from "./sections/Overview";
import UnusedDashboards from "./sections/UnusedDashboards";
import DashboardAdmin from "./sections/DashboardAdmin";
import AccessRequests from "./sections/AccessRequests";
import Header from "../Header";

const Owner = ({ theme }) => {
  const [expandedSections, setExpandedSections] = useState({
    overview: true,
    unused: true,
    admin: true,
    access: true,
  });
  const [runAs] = useState("owner");
  const [activeTab, setActiveTab] = useState("overview");

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };
  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* <h2>Owners Panel</h2> */}
      <Header theme={theme} title="Owners Panel" />
      <div className=" mx-auto py-6 px-4 sm:px-6 lg:px-8">
        {/* <p>Welcome to the Dashboard Owners Panel!</p> */}
        <div className="bg-white shadow rounded-lg mb-6 p-6">
          <h1 className="text-xl font-bold text-gray-700">
            Welcome to Owners Panel!
          </h1>
        </div>

        <div className="bg-white shadow rounded-lg overflow-hidden mb-6">
          <div className="border-b border-gray-200">
            <nav className="flex -mb-px">
              <button
                onClick={() => handleTabChange("overview")}
                className={`py-4 px-6 text-center border-b-2 font-medium text-md flex-1 ${
                  activeTab === "overview"
                    ? `!font-bold`
                    : "border-transparent text-gray-700 hover:text-gray-700 hover:border-gray-700"
                }`}
                style={
                  activeTab === "overview"
                    ? {
                        borderBottom: `2px solid ${theme.leftNavBackgroundColor}`,
                        color: theme.leftNavBackgroundColor,
                      }
                    : {}
                }
              >
                Dashboard Usage {runAs === "admin" ? " - Last 90 Days" : ""}
              </button>
              <button
                onClick={() => handleTabChange("unused")}
                className={`py-4 px-6 text-center border-b-2 font-medium text-md flex-1 ${
                  activeTab === "unused"
                    ? `!font-bold`
                    : "border-transparent text-gray-700 hover:text-gray-700 hover:border-gray-700"
                }`}
                style={
                  activeTab === "unused"
                    ? {
                        borderBottom: `2px solid ${theme.leftNavBackgroundColor}`,
                        color: theme.leftNavBackgroundColor,
                      }
                    : {}
                }
              >
                Unused Dashboards
              </button>
              <button
                onClick={() => handleTabChange("admin")}
                className={`py-4 px-6 text-center border-b-2 font-medium text-md flex-1 ${
                  activeTab === "admin"
                    ? `!font-bold`
                    : "border-transparent text-gray-700 hover:text-gray-700 hover:border-gray-700"
                }`}
                style={
                  activeTab === "admin"
                    ? {
                        borderBottom: `2px solid ${theme.leftNavBackgroundColor}`,
                        color: theme.leftNavBackgroundColor,
                      }
                    : {}
                }
              >
                Dashboards Admin
              </button>
              <button
                onClick={() => handleTabChange("access")}
                className={`py-4 px-6 text-center border-b-2 font-medium text-md flex-1 ${
                  activeTab === "access"
                    ? `!font-bold`
                    : "border-transparent text-gray-700 hover:text-gray-700 hover:border-gray-700"
                }`}
                style={
                  activeTab === "access"
                    ? {
                        borderBottom: `2px solid ${theme.leftNavBackgroundColor}`,
                        color: theme.leftNavBackgroundColor,
                      }
                    : {}
                }
              >
                Access Requests
              </button>
            </nav>
          </div>
        </div>


        <div className="bg-white shadow rounded-lg overflow-hidden">
            <div className="p-6">
                {activeTab === 'overview' && (
            <Overview
                expandedSections={expandedSections}
                toggleSection={toggleSection}
                runAs={runAs}
                theme={theme} // Pass the theme object
            />)}
            {activeTab === 'unused' && (
            <UnusedDashboards
                expandedSections={expandedSections}
                toggleSection={toggleSection}
                runAs={runAs}
                theme={theme}
            />)}
            {activeTab === 'admin' && (
            <DashboardAdmin
                expandedSections={expandedSections}
                toggleSection={toggleSection}
                runAs={runAs}
                theme={theme}
            />)}
            {activeTab === 'access' && (
            <AccessRequests
                expandedSections={expandedSections}
                toggleSection={toggleSection}
                runAs={runAs}
            />)}
            </div>
        </div>
      </div>
    </div>
  );
};

export default Owner;
